import { forwardRef } from "react";

import { ApiRoute } from "../../types";
import * as Style from "./RoutesList.style";

type Props<T extends { route: ApiRoute }> = {
  items: T[];
  selectedRouteUUID?: string | null;
  onSelectRoute: (routeUUID: string | null) => void;
  headerRightText?: string;
  renderItemContents: (item: T) => React.ReactElement;
  renderEmpty: () => React.ReactElement;
};

export const RouteName = Style.Name;

const RoutesListInner = <T extends { route: ApiRoute }>(
  {
    items,
    selectedRouteUUID,
    onSelectRoute,
    headerRightText,
    renderItemContents,
    renderEmpty,
  }: Props<T>,
  ref: React.ForwardedRef<HTMLDivElement>
) => {
  return (
    <Style.Container ref={ref}>
      <Style.RouteListHeader>
        <Style.RouteListHeaderText>Routes</Style.RouteListHeaderText>
        {headerRightText ? (
          <Style.RouteListHeaderText>
            {headerRightText}
          </Style.RouteListHeaderText>
        ) : null}
      </Style.RouteListHeader>
      {!items.length ? renderEmpty() : null}
      {items.map((item) => (
        <Style.ListItem
          data-uuid={item.route.uuid}
          key={item.route.uuid}
          isSelected={item.route.uuid === selectedRouteUUID}
          onClick={() => onSelectRoute(item.route.uuid)}
        >
          {renderItemContents(item)}
        </Style.ListItem>
      ))}
    </Style.Container>
  );
};
const RoutesList = forwardRef(RoutesListInner) as <
  T extends { route: ApiRoute }
>(
  props: Props<T> & { ref?: React.Ref<HTMLDivElement> }
) => React.ReactElement;

export default RoutesList;
